/**
 * Valori di default. Da non utilizzare direttamente, prenderli da
 * `props.theme` di styled-components.
 */
export const uiTheme = {
  contentMaxWidth: 1200,
  layoutHeaderHeight: 64, // altezza totale della header -> influenza gli elementi esterni alla header
  layoutHeaderContentHeight: 64, // altezza interna del contenuto del header
  layoutSiderWidth: 200,
  layoutSiderCollapsedWidth: 60,
  moduleSiderWidth: 300,

  // Underline BreadCrumb
  breadcrumbTextDecoration: 'none',

  // variabile per indicare la posizione del Tag di stato nella pagina di dettaglio della richiesta
  submissionStateTagPositionAfter: false,
  // indica se color del menu delle lingue deve essere bianco
  whiteLanguageMenuColor: false,

  // larghezza colonna per la navigazione delle sezioni in compilazione
  sectionNavigationWidth: 250,
  sectionNavigationWidthMd: 180,

  // footer statico che contiene la versione
  layoutVersionFooterHeight: 25,

  // Button - per esportare nel tema il corrispettivo impostato nel token (Button.lineWidth)
  tokenButtonLineWidth: 1,

  boxShadowCustomLine:
    '0px 1px 1px 0 rgba(100, 116, 139, 0.08), 0px 1px 2px 0 rgba(100, 116, 139, 0.1);',
  // [Accessibilità] Colore del bordo di evidenziazione del Focus
  focusOutlineColor: '#2384d9',
  focusOutlineNegativeColor: '#c3e3ff',
  // [Accessibilità] Colore titolo della tabella
  tableTitleBackgroundColor: '#48548B',
  // RTE
  // margine inferiore per i tag html display: block (p, ul, ol, ecc.)
  rteHtmlTagMarginBottom: 0, // 0.4,
  rteLinkColor: '#0066cc',
  rteLinkHoverColor: '#0053a6',

  // Widget
  compactWidgetHeight: 72,

  // Padding Base per gli elemento di configurazione degli Elementi
  paddingBaseCalc: 4,

  spaceImageUrl: require('./images/space.png'),

  // colori stato compilazione modulo
  moduleStateErrorColor: '#cb1d15',
  moduleStateValidColor: '#757575',
  moduleStateSignColor: '#531dab',
  moduleStateCompletedColor: '#008554',
  // colori dei banner di riepilogo compilazione modulo
  moduleDelegateColor: '#722ed1',
  // A11Y accessibilità
  colorTextPlaceholderDisabled: '#606060',

  // dossier card
  colorBgDossierCard: '#d9edfc', //'#d9eef7',

  // Indica se visualizzare il numero di protocollo nell'elenco delle richieste
  // o il numero istanza
  showProtocolNumberAsSubmissionNumberColumn: false,

  // Indica se visualizzare la colonna con la fase nella lista delle richieste personali
  showPhaseSubmissionColumn: false,
  // Indica se visualizzare il filtro per Area
  showAreaInquiryFilter: false,

  // Flags per la visualizzazione del drawer PDF
  viewPdfLabel: 'Apri',
  enablePdfDrawer: false,

  openModulePdfInNewWindow: false,

  // Indica se è necessaria la PEC per l'ufficio
  isOfficePecRequired: true,

  // Indica se mostrare l'icona alternativa per il riepilogo
  showAlternateSummaryIcon: false,

  // Se impotata a true, reindirizza al modulo principale all'avvio di una domanda
  redirectToFirstModule: false,

  // Indica se mostrare il badge di validazione della sezione
  showSummarySectionBadge: true,

  // Flag per nascondere la tab dei documenti nella pagina del procedimento
  hideProcedureDocumentsTab: false,

  // Flag per visualizzare anche il codice nella selezione dell'ufficio
  showOfficeCodeDropdown: false,
};

/**
 * Espone il tema dell'interfaccia utente, in modo che sia
 * possibile sovrascriverlo.
 */
export type IUiTheme = typeof uiTheme;
